import React from 'react';
import PropTypes from 'prop-types';
import { IconInfo, IconInfoFilled } from 'svgIcons/MotionPortalIcons';
import colors from 'theme/_colors.scss';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { GeneralTable } from 'sharedComponents/GeneralTable';
import { translate } from 'helpers/translateHelper';

const ReleventSignalsButton = ({ info, setInfo, getColumns, getTableData }) => {
    const handleClose = () => setInfo(false);

    return (
        <>
            <button
                type='button'
                className='drive-anomaly-relevant-signals'
                onClick={() => setInfo(true)}
            >
                <span className='info-icon'>
                    <IconInfo width={'16px'} height={'16px'} color={colors.guageBlue} />
                </span>
                <span className='related-signals-text'>
                    {translate('ABB.Powertrain.Frontend.anomalyDetectionReleventSignals')}
                </span>
            </button>
            {info &&
                <GeneralDialog
                    className='anomaly-relevant-signals-dialog'
                    show={info}
                    close={handleClose}
                    title={
                        <>
                            <IconInfo width={'17px'} height={'17px'} />
                            <span className='anomaly-relevant-signals-dialog-title'>
                                {translate('ABB.Powertrain.Frontend.CoolingAnomalyReleventSignalsModelTitle')}
                            </span>
                        </>
                    }
                    closeButton={true}
                    acceptButtonProps={{
                        text: translate('ABB.Powertrain.Frontend.closeBtnLbl'),
                        onClick: handleClose,
                        type: 'primary'
                    }}
                    modalClassName={'anomaly-relevant-signals-model-dialog'}
                >
                    <div className='relevent-signals-info-message'>
                        <span className='icon'>
                            <IconInfoFilled width={'14px'} height={'14px'} color={colors.dodgerBlue} />
                        </span>
                        <span className='title'>
                            {translate('ABB.Powertrain.Frontend.anomalyDetectReleventSignalsInfoText')}
                        </span>
                    </div>
                    <GeneralTable
                        className='related-signals-table'
                        type='primary'
                        tableKey='id'
                        columns={getColumns()}
                        data={getTableData()}
                    />
                </GeneralDialog>
            }
        </>
    );
};

ReleventSignalsButton.propTypes = {
    info: PropTypes.bool.isRequired,
    setInfo: PropTypes.func.isRequired,
    getColumns: PropTypes.func.isRequired,
    getTableData: PropTypes.func.isRequired
};

export default ReleventSignalsButton;
